import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Typography, makeStyles } from '@material-ui/core';
import AreaSelect from '../common/AreaSelect';
import FieldError from './FieldError';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        marginBottom: "1.5rem",
        width: '100%',
    },
    label: {
        display: "block",
        fontWeight: "bold",
        marginBottom: "0.5rem",
        color: "#26344a",
        fontSize: "1.8rem",
    },
    help: {
        color: "#23d160",
        fontSize: "1.1rem",
        marginTop: "0.25rem",
        fontStyle: 'italic',
    },
    areaSelect: {
        '& select': {
            width: '100%',
            padding: '0.625em 0.75em',
            border: '1px solid #dbdbdb',
            borderRadius: '4px',
            fontSize: '1.6rem',
            backgroundColor: '#fff',
            transition: 'border-color 0.2s',
            '&:focus': {
                outline: 'none',
                borderColor: '#3273dc',
            },
            '&:hover': {
                borderColor: '#3273dc',
            },
        },
    },
}));

const AreaField = ({
    name,
    className,
    label,
    info,
}) => {
    const classes = useStyles();
    const { register, errors, setValue, watch } = useFormContext();

    const selectedAreaId = watch(name);

    useEffect(() => {
        register({ name: `${name}`, type: 'custom' });
    }, [register, name])

    const handleAreaChange = areaId => {
        setValue(name, areaId);
    }

    const hasError = errors[name];
    const errorMessage = hasError ?
        (hasError.type === 'required' ? 'この項目は必須です' :
            hasError.message || '入力内容を確認してください') : '';

    return (
        <div className={`${classes.wrapper} ${className || ''}`}>
            <Typography variant="body1" className={classes.label}>
                {label}
            </Typography>
            <div className={classes.areaSelect}>
                <AreaSelect onChange={handleAreaChange} value={selectedAreaId} emptyString='未設定' />
            </div>
            {info && <Typography variant="body2" className={classes.help}>{info}</Typography>}
            {hasError && (
                <Typography variant="body2" color="error" className={classes.help}>
                    {errorMessage}
                </Typography>
            )}
        </div>
    )
}

export default AreaField;
